<style lang="less" scoped>
.blk-rules {
  background: #F1F0F0;
}
.blk-awards {
  background: #fff;
}
.blk-rules .van-button,
.blk-awards .van-button {
  width: 5.6rem;
  margin: 0 auto;
}
.blk-awards .van-button {
  margin-top: -.4rem;
}
.blk-rules .van-button {
  margin-top: .3rem;
}
</style>
<template>
  <div class="page page-index ">

    <div class="page__inner">
    <k-block name="index_1_top" />
    <sect-status />

    <div class="blk-rules">
      <k-block name="index_2_rule" />
      <van-button size="big" block type="danger" @click="goRules">活动规则 </van-button>
      <k-block name="index_3_qr_code" />
    </div>
    <k-block name="index_4_time" />

    <div class="blk-awards">
      <k-block name="index_5_awards" />
      <van-button size="big" block type="danger" @click="goAwards">奖项设置</van-button>
    </div>
    <!-- <sect-status /> -->
    <k-block name="index_6_organizer" />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        value: 50
      }
    },
    computed: {

    },
    methods: {
      goAwards() {
        this.$router.push("/match/awards")
      },
      goRules() {
        this.$router.push("/match/rules")
      }
    }
  };

</script>
